import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import _ from 'lodash'
import Actions from '../../../appFlux/action'
import { SelectDD , ExternalDD } from '../../../common/dropdowns';

class EditMyContactModal extends React.Component {
    constructor(props) {
        super(props);
        var { modal, toggle, contactInfo } = props
        this.state = {
            contactInfo: _.cloneDeep(contactInfo),
            error: []
        }
    }
    componentWillReceiveProps(){
        this.setState({error: []})
    }

    setContactInfo = (value, param) => {
        var { contactInfo } = this.state
        contactInfo[param] = value
        console.log(contactInfo)
        this.setState({contactInfo})
    }

    validate = () => {
        var { contactInfo } = this.state
        var error = []
        if (!contactInfo.addressField1) error.push("Please enter House Name and Number")
        if (!contactInfo.addressField2) error.push("Please enter Street Address 1")
        if (!contactInfo.city) error.push("Please enter City")
        if (!contactInfo.state) error.push("Please enter State")
        if (!contactInfo.country) error.push("Please enter Country")
        if (!contactInfo.email) error.push("Please enter E-Mail")
        if (!contactInfo.phone) error.push("Please enter Phone")

        if(error.length == 0) return true
        else this.setState({error})
    }

    reset = () => this.setState({contactInfo: _.cloneDeep(this.props.contactInfo)})
    save = () => {
    if(this.validate() == true){
        Actions.setContactInfo(this.state.contactInfo)
        this.props.toggle()
    }
    }

    render() {
        var { modal, toggle } = this.props
        var { contactInfo, error } = this.state
        return (
            <Modal isOpen={modal} toggle={toggle}  className="modal-wrap wd-700"> 
            {/* wd-x , x works from 0 to 1000 in multiples of 10. so other widths please make class  */}
             <div className="d-flex pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
                 <div className="modal-header">Edit Contact Information</div>
                 <div className="v-align f-right" style={{marginLeft:'auto'}}>
                     <i className="fa fa-cog modal-close mg-r-15" ></i>
                     <i className="far fa-question-circle modal-close mg-r-15" ></i>            
                     <i className="fas fa-times modal-close" onClick={toggle}></i>
                 </div>
             </div>   
             <hr className="mg-r-0"></hr>
             <div className="modal-block">
                 <div >                
                     <div className="modal-subheader">Address
                         <span className="mandatory-field">*</span>
                     </div>
                     <div className="modal-sublistheader">House Name and Number</div>
                     <div><input value={contactInfo.addressField1} onChange={(e) => this.setContactInfo(e.target.value, "addressField1")} type="text" className="form-control"></input></div>  
                     <div className="modal-sublistheader">Street Address 1</div>
                     <div><input value={contactInfo.addressField2} onChange={(e) => this.setContactInfo(e.target.value, "addressField2")} type="text" className="form-control"></input></div>
                     <div className="modal-sublistheader">Street Address 2</div>
                     <div><input value={contactInfo.addressField3} onChange={(e) => this.setContactInfo(e.target.value, "addressField1")} type="text" className="form-control"></input></div> 
                     <div className="row">
                         <div className="col-md-6">   
                         <div className="modal-sublistheader">City</div>
                         <div><input value={contactInfo.city} onChange={(e) => this.setContactInfo(e.target.value, "city")} type="text" className="form-control"></input></div> 
                         </div>
                         <div className="col-md-6">
                         <div className="modal-sublistheader">Zip Code</div>
                         <div><input value={contactInfo.pin} onChange={(e) => this.setContactInfo(e.target.value, "pin")} type="text" className="form-control"></input></div>
                         </div>   
                     </div>   
                     <div className="row">
                         <div className="col-md-6">   
                         <div className="modal-sublistheader">State</div>
                         <div><input value={contactInfo.state} onChange={(e) => this.setContactInfo(e.target.value, "state")} type="text" className="form-control"></input></div> 
                         </div>
                         <div className="col-md-6">
                         <div className="modal-sublistheader">Country</div>
                         <div><input value={contactInfo.country} onChange={(e) => this.setContactInfo(e.target.value, "country")} type="text" className="form-control"></input></div>
                         </div>   
                     </div>                     
                 </div> 
             </div> 
             <hr className="mg-0 "></hr>
             <div className="modal-block">          
                 <div className="mg-t-10">
                     <div className="modal-subheader">e-mail
                         <span className="mandatory-field">*</span>
                     </div> 
                     <div><input value={contactInfo.email} onChange={(e) => this.setContactInfo(e.target.value, "email")} type="text" className="form-control"></input></div>          
                 </div>
             </div>
             <hr className="mg-0 "></hr>
             <div className="modal-block">
                 <div className="mg-t-10 mg-b-15">
                     <div className="v-align">
                         <div className="modal-subheader">Phone
                             <span className="mandatory-field">*</span>
                         </div> 
                     </div>
                     <div><input value={contactInfo.phone} onChange={(e) => this.setContactInfo(e.target.value, "phone")} type="text" className="form-control"></input></div>
                     <div className="v-align">
                         <div className="modal-subheader">Secondary Phone</div> 
                     </div>
                     <div><input value={contactInfo.phone2} onChange={(e) => this.setContactInfo(e.target.value, "phone2")} type="text" className="form-control"></input></div>      
                 </div>
                 {error.length > 0 ?(
                    <div className="error-display">
                        {error.map(err => <div>{err}</div>)}
                    </div>
                 ): null}
             </div>  
                 <hr className="mg-0 "></hr>
             <div className="pd-20 box-shadow-top">
                <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>  
                <button className="btn btn-primary-lite f-right mg-r-15" onClick={this.save}>Save</button>
                <button className="btn btn-success-lite mg-r-15 f-right" onClick={this.reset}>Reset</button>  
             </div>
                      
         </Modal>
        )
    }
}
export default EditMyContactModal;